// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"Om-z","categoryName":"Pm-z","categoryImage":"Qm-z","categoryContent":"Rm-z","bottomAligned":"Sm-z"};